import {icn} from "./tools/UIIcons";

export const defaultPath = "/miscon_overview";

export const routes = {
    "/miscon_overview": { name: "Misconfiguration Overview", component: () => import("./pages/MisconOverview") },
    "/miscon_overview/category": { name: "Misconfiguration Categories", component: () => import("./pages/MisconCategory") },
    "/miscon_overview/topic": { name: "Misconfiguration Topic", tName: "$1", component: () => import("./pages/TopicMiscon") },
    "/action_log": { name: "Action Log", component: () => import("./pages/ActionLog") },
    "/action_log/explore_action": { name: "Explore action", tName: "$1", component: () => import("./pages/ActionExplore") },
    "/benchmark/CIS": { name: "CIS Security Compliance Standards", component: () => import("./pages/Benchmark") },
    "/benchmark/CIS/topic": { name: "CIS Topic", tName: "$1", component: () => import("./pages/TopicBenchmark") },
    "/active_directory": { name: "Active Directory & Group Policy Objects", component: () => import("./pages/ActiveDirectory") },
    "/exec_summary": { name: "Executive Summary", component: () => import("./pages/ExecutiveSummary") },
    "/intune": { name: "Microsoft Intune", component: () => import("./pages/Intune") },

    "/device_groups": { name: "Device Groups", component: () => import("./pages/DeviceGroups") },
    "/permissions": { name: "Permissions", component: () => import("./pages/RolesPermissions") },
    "/integrations": { name: "Integrations", component: () => import("./pages/Integrations") },
    "/license": { name: "License", component: () => import("./app/UseLicense") },
    "/health": { name: "Health", component: () => import("./pages/Health") },
    "/health/devices": { name: "Device Manifest", component: () => import("./pages/HealthDevices") },
    "/device_info": { name: "Device Information", tName: "$1", component: () => import("./pages/DeviceInfo") },
};

export const menu = [
    {h: "Manage", staticMenu: true, subMenu: [
            { h: "Misconfiguration", k: "/miscon_overview", icon: "eye-outline text-lg" },
            { h: "Security Compliance", icon: "documents text-sm", subMenu: [
                    { h: "CIS / NIST", k: "/benchmark/CIS" },
                    { h: "Cyber Essentials", tip: "Coming soon..." },
                    { h: "Build Your Own", tip: "Coming soon..." }
                ]},
            // { h: "Policy Validation", icon: "shield", subMenu: [{ h: "GPO" }, { h: "GPO Profiler" }, { h: "Intune" }, { h: "Intune Profiler" }] },
            { h: "AD GPO", k: "/active_directory", icon: "fire" },
            { h: "Microsoft Intune", k: "/intune", icon: icn.intune },
            { h: "Action Log", k: "/action_log", icon: "calendar-check-o" },
            { h: "Executive Summary", k: "/exec_summary", icon: "briefcase" },
        ]
    },
    {h: "Settings", className: "text-base", subMenu: [
            { h: "System Health", icon: "rocket", k: "/health", notifs: {clientLog: "Client Logs"} },
            { h: "Device Groups",icon: "make-group" , k: "/device_groups" },
            { h: "Permissions", icon: "configs", k: "/permissions", perms: {admin: 1} },
            { h: "Integrations", icon: "integrations", k: "/integrations", perms: {admin: 1} },
            { h: "License", icon: "liscense text-sm", k: "/license", perms: {admin: 1} },
            { h: "VDI Images", icon: "vdi", Xto: "/vdi_images", perms: {admin: 1}, tip: "Coming soon..." },
        ]
    },
];

export const helpActions = [
    {h: "Can we help?", icon: "room_service", className: "z-20", subMenu: [
            { h: "Welcome tutorial", icon: "video" },
            { h: "Expand license", icon: "cart" },
            { h: "Missing a feature?", icon: "screw" },
            { h: "Report a bug", icon: "bug" },
            { h: "Send log", icon: "report" },
        ]
    }
];


// Intergrations: APIs, ServiceNow, Splunk, Azure Sentinel, Axonious,
// Intergrations: View guide - opens link to website in new tab.
// License: Health per device type, hint about Azure / AWS marketplaces

// Device Groups
// Group Name, Groups Desc, Device Count, Permitted Roles, Create Date, Modify Date
//   side panel: Count per OS type, utilized by,
//   actions: add group, edit, delete

// Permissions
// Users:  list of all currently defined users in our system:
//   User Name, Full Name, Title, Role(s?)
// Roles:  list of defined roles - with side panel showing device totals, group type (static / dynamic):
//   Roles Name, Description, Memebers,
//      Device Permissions: by Device Groups, By OS Type
//         Access Type: View Only / Full Access
//      Module Permissions: checkboxes... (miscon, benchmark...)

// make sure system by default has an Admin role
//